import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import orderBy from 'lodash/orderBy';

import { getNodes } from '../../utils';

import Grid from '../grid/grid';
import Video from './video';
import {
  SmallTitle,
  SubTitle,
  Title,
  RedDot
} from '../elements';
import { settingsVideos } from '../grid/constants';

export default () => (
  <StaticQuery
    query={graphql`
      query VideosQuery {
        videos: allWordpressWpVideos(sort: { fields: acf___released, order: DESC }) {
          edges {
            node {
              id
              title
              menu_order
              featured_media {
                source_url
                localFile {
                  childImageSharp {
                    fluid(
                      maxWidth: 500
                      traceSVG: {
                        color: "#FFE1E2"
                      }
                    ) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                  }
                }
              }
              acf {
                video
                artist
                description
                duration
                released
              }
            }
          }
        }
      }
    `}
    render={data => <Videos data={data} />}
  />
);

const Videos = ({ data }) => {
  const videos = orderBy(getNodes(data.videos), 'menu_order');

  return (
    <div className="site-section" id="videos" css={{ padding: '6rem 0' }}>
      <section className="section">
        <div className="container">
          <div css={{ maxWidth: '50rem' }}>
            <SmallTitle>
              Music & Videos
            </SmallTitle>

            <Title>
              Watch, as our stories unfold<RedDot /><br />
              One video at a time<RedDot />
            </Title>
            <SubTitle>
              And yet, so <em>much</em> more to be told.
            </SubTitle>
          </div>
        </div>
      </section>

      {videos && (
        <Grid
          data={videos}
          style={{ overflowX: 'scroll', paddingBottom: '0.5rem' }}
          slickSettings={settingsVideos}
          render={({ item, ...props }) => (
            <Video
              video={item}
              {...props}
            />
          )}
        />
      )}
    </div>
  );
};
